module.exports = __webpack_public_path__ + "img/2.927bef85.jpg";